import {Box, Container, Grid, Typography, useMediaQuery, useTheme} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import imgDesktop from 'src/Assets/Images/Broadtech/broadtech-desktop.png';
import imgMobile from 'src/Assets/Images/Broadtech/broadtech-mobile.png';
import imgWebSmall from 'src/Assets/Images/Broadtech/broadtech-web-small.png';
import imgWeb from 'src/Assets/Images/Broadtech/broadtech-web.png';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';

import {broadtechHorizonStyles} from './BroadtechHorizonStyles';

const BroadtechHorizon = (props: BroadtechHorizonProps) => {
	const theme = useTheme();
	const matchesMobile = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<section className={props.classes.section} id={props.anchor}>
			<Container className={props.classes.container} maxWidth="lg">
				<Grid container alignItems={matchesMobile ? 'flex-start' : 'center'} direction="row" justifyContent="center">
					<Grid className={props.classes.grid} xs={6} sm={6} item md={6}>
						<Box className={`${props.classes.imageBox} ${props.classes.imageBoxWeb}`}>
							<Typography variant="subtitle1" className={`${props.classes.subtitle} ${props.classes.subtitleWeb}`}>
								{props.t('broadtech-case-web')}
							</Typography>
							<img
								className={`${props.classes.image} ${props.classes.imageWeb}`}
								src={matchesMobile ? imgWebSmall : imgWeb}
								alt={props.t('broadtech-case-web')}
							/>
						</Box>
					</Grid>
					<Grid className={props.classes.grid} xs={6} sm={6} item md={6}>
						<Typography variant="h3" className={props.classes.title}>
							{props.t('broadtech-title')}
						</Typography>
					</Grid>
				</Grid>
				<Grid className={props.classes.secondRow} container>
					<Grid className={props.classes.grid} xs={6} sm={6} item md={6}>
						<Box className={`${props.classes.imageBox} ${props.classes.imageBoxMobile}`}>
							<Typography variant="subtitle1" className={`${props.classes.subtitle} ${props.classes.subtitleMobile}`}>
								{props.t('broadtech-case-mobile')}
							</Typography>
							<img className={props.classes.image} src={imgMobile} alt={props.t('broadtech-case-mobile')} />
						</Box>
						<Box className={`${props.classes.imageBox} ${props.classes.imageBoxDesktop}`}>
							<Typography variant="subtitle1" className={`${props.classes.subtitle} ${props.classes.subtitleDesktop}`}>
								{props.t('broadtech-case-desktop')}
							</Typography>
							<img
								className={`${props.classes.image} ${props.classes.imageMob}`}
								src={imgDesktop}
								alt={props.t('broadtech-case-desktop')}
							/>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};

interface BroadtechHorizonProps extends IAnchorable, WithTranslation, WithStyles {}

export default withStyles(broadtechHorizonStyles)(withTranslation('broadtech')(BroadtechHorizon));
